import { addLocale, useLocale } from 'ttag';
import * as cookie from './cookie';

const LOCALE_COOKIE = '__locale';

export function getLocale() {
  if(!cookie.get(LOCALE_COOKIE) && new URLSearchParams(window.location.search).get('lang')) {
    saveLocale(new URLSearchParams(window.location.search).get('lang'));
  }
  return cookie.get(LOCALE_COOKIE) || 'hu';
}

export function saveLocale(locale) {
  cookie.set(LOCALE_COOKIE, locale);
}

// setup
const locale = getLocale();

if (locale !== 'hu') {
  const translationsObj = require(`../../../trans/${locale}.po.json`);
  // setDefaultLang('hu');
  addLocale(locale, translationsObj);
  useLocale(locale);
}